import React from 'react'
import { Button, Row, Col } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const ErrorOne = () => {
	// const theme = useSelector(state => state.theme.currentTheme)
	return (
		<div className="">
					<Row align="middle">
						<Col xs={24} sm={24} md={8}>
							<h1 className="font-weight-bold mb-4 display-4">No tienes permiso para acceder a esta página</h1>
							<p className="font-size-md mb-4">Si crees que deberias poder ver algo contacta con tu institución.</p>
							<Link to='/app'>
								<Button type="primary" icon={<ArrowLeftOutlined />}>Regresar</Button>
							</Link>
						</Col>
						<Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
							{/* <img className="img-fluid mt-md-0 mt-4" src="/img/others/img-20.png" alt="" /> */}
						</Col>
					</Row>
		</div>
	)
}

export default ErrorOne
